import React, { Fragment, useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Profile from "./Profile";
import TransporterCompany from "./TransporterCompany";
import TransporterMailing from "./TransporterMailing";
import TransporterContact from "./TransporterContact";
import TransporterAlias from "./TransporterAlias";
import TransporterOwners from "./TransporterOwners";
import { formatTransporterStatus } from "../../shared/functions/Functions";
import TransporterEpaIds from "./TransporterEpaIds";
import TransporterTerminalLocations from "./TransporterTerminalLocations";
import TransporterVariances from "./TransporterVariances";
import { Section, Loading } from "../../shared";
import TransporterImages from "./TransporterImages";
import { useIsRegulator } from "../../../hooks";

export default function TransporterProfile(props) {
  const isRegulator = useIsRegulator();
  const [isFetching, setIsFetching] = useState(false);
  const [data, setData] = useState([]);
  const fetchTransporter = () => {
    setIsFetching(true);
    axios
      .get(
        `api/v1/hwts/search/transporter?regid=${props.match.params.id}`
      )
      .then((transporter) => {
        setData(transporter.data.data);
        setIsFetching(false);
      });
  };
  useEffect(() => {
    document.title = `HWTS: Transporter: ${props.match.params.id}`;
    fetchTransporter();
  }, [])
  return (
    isFetching === true ? <Loading /> :
      (isFetching === false && data.length === 0) ?
        <h4 style={{ marginTop: "80px", textAlign: "center" }}>
          A Transporter with a Registration Number of
        {props.match.params.id} does not exist.
      </h4>
        :
        <Fragment>
          <Section
            type="standout"
            title="Transporter Profile"
          />
          <div className="container">
            <ol className="breadcrumb">
              <li>
                <Link to="/reports" title="Home page">
                  HWTS Reports
            </Link>
              </li>
              <li>
                <Link to="/reports/transporter" title="Home page">
                  Transporters
            </Link>
              </li>
              <li className="active">View Transporter</li>
            </ol>
            <div className="facility-header ">
              <span className="facility-title">
                {data.details[0].TRANS_NAME}
              </span>
              {/* <span className="facility-title-epaid">{this.state.transporter.details[0].REGN_ID}</span> */}
              <div className="facility-header-status-print">
                <span className="facility-status">
                  Status:{" "}
                  <span style={{ color: formatTransporterStatus(data.details[0].STATUS_IND).toLowerCase() === "suspended"
                                ? "red" : "",
                              }}>
                    {formatTransporterStatus(data.details[0].STATUS_IND)}
                  </span>
                </span>
                <a
                  href={`https://hwts.dtsc.ca.gov/hwts_Reports/ReportPages/Report04.aspx?trans=${data.details[0].REGN_ID}`}
                  target="_"
                  className="ca-gov-icon-print hidden-print"
                  title="Generate Printable EPA Profile"
                />
              </div>
              <hr />
            </div>
            <div className="group">
              <div className="half">
                <Profile details={data.details} />
              </div>
              <div className="half">
                <TransporterAlias alias={data.trans_aka} />
              </div>
            </div>
            <div className="group">
              <div className="quarter">
                <TransporterContact contactDetails={data.details} />
              </div>
              <div className="quarter">
                <TransporterOwners owners={data.owners} />
              </div>
              <div className="quarter">
                <TransporterCompany companyAddress={data.details} />
              </div>
              <div className="quarter">
                <TransporterMailing mailingAddress={data.details} />
              </div>
            </div>
            <div className="group">
              <div className="full" style={{ padding: "15px" }}>
                {/* <EpaIDGrid epa_ID={transporter.transporter}/>    */}
                <TransporterEpaIds regID={props.match.params.id} transName={data.details[0].TRANS_NAME} epaIds={data.transporter} isRegulator={isRegulator} />
              </div>
            </div>
            <div className="group">
              <div className="full" style={{ padding: "15px" }}>
                <TransporterTerminalLocations regID={props.match.params.id} transName={data.details[0].TRANS_NAME} transLocs={data.terminalLocations}/>
              </div>
            </div>
            {isRegulator === true && (
              <div className="group">
                <h3
                  style={{
                    textAlign: "center",
                  }}
                >
                  Transporter Registration Application by Year
                </h3>
                <div className="full" style={{ padding: "15px" }}>
                  <TransporterImages regID={props.match.params.id} />
                </div>
              </div>
            )}
            
            {isRegulator === true && (
              <div className="group">
                <div className="full" style={{ padding: "15px" }}>
                  <TransporterVariances regID={props.match.params.id} transName={data.details[0].TRANS_NAME}/>
                </div>
              </div>
            )}
          </div>
        </Fragment>
  );
};


